import generatedTranslations from './publicSiteTranslations.generated.json';
import { normalizeLanguage } from './languages';
import { translateInline } from './inlineTranslations';

type TranslationTable = Record<string, Record<string, string>>;

const translations = generatedTranslations as TranslationTable;

export const translatePublicSite = (
  language: string | null | undefined,
  english: string,
  hindiFallback?: string,
) => {
  const normalized = normalizeLanguage(language);
  if (normalized === 'en') return english;
  return translations[normalized]?.[english]
    || translateInline(normalized, english, hindiFallback);
};
